import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("sbb_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const imgSrc = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  return `${process.env.REACT_APP_BACKEND_URL}${src}`;
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return String(detail);
};
